/**
 * Retomar a criação parada pela gestão (#769), sem tela: o que mostrar depois
 * da resposta ou da falha do servidor.
 */

import { ErroDaApi, type CriacaoRetomada } from '@cliqcrm/contracts';
import { recadoDeErro } from '@/shared/api/recado-de-erro';

/**
 * Enquanto retoma, quando o administrador guardado não serve e a criação se
 * refaz pelo formulário, quando não terminou ou quando falhou.
 */
export type EstadoDaRetomada =
  | { readonly fase: 'retomando' }
  | { readonly fase: 'refazer'; readonly texto: string }
  | { readonly fase: 'nao_terminou'; readonly pendencias: readonly string[] }
  | { readonly fase: 'falhou'; readonly motivo: string };

/**
 * Depois da resposta. Terminou: a faixa some, e as pendências que sobraram (o
 * administrador sem senha, a configuração que não terminou) ficam para a tela
 * mostrar fora dela. Não terminou: a faixa diz o porquê.
 */
export function depoisDaResposta(saida: CriacaoRetomada): {
  readonly retomada: EstadoDaRetomada | null;
  readonly pendencias: readonly string[];
} {
  return saida.status === 'ativo'
    ? { retomada: null, pendencias: saida.pendencias }
    : { retomada: { fase: 'nao_terminou', pendencias: saida.pendencias }, pendencias: [] };
}

/**
 * Depois da falha. O administrador guardado que não serve (o e-mail que já tem
 * conta em outra organização, que o Retomar não confirma, ou o das contas
 * técnicas) manda refazer pelo formulário, com o texto do servidor. O pedido
 * que não está mais guardado pede reler o detalhe, que passa a mandar para o
 * formulário. O resto vira o motivo.
 */
export function estadoDaFalha(falha: unknown): EstadoDaRetomada | 'reler' {
  if (
    falha instanceof ErroDaApi &&
    (falha.problema.errors ?? []).some((erro) => erro.campo === 'admin.email')
  ) {
    return {
      fase: 'refazer',
      texto:
        falha.problema.detail ??
        'O administrador guardado não serve para retomar: refaça a criação pelo formulário.',
    };
  }
  if (
    falha instanceof ErroDaApi &&
    (falha.problema.errors ?? []).some((erro) => erro.campo === 'pedido')
  ) {
    return 'reler';
  }
  return {
    fase: 'falhou',
    motivo: recadoDeErro(falha, { generica: 'Não foi possível retomar a criação. Tente de novo.' }),
  };
}
